export const API = {
  packageDetails: 'http://registry.npmjs.org/',
  // npmPackage: 'http://registry.npmjs.org/+react+/latest',
  search: 'http://www.npmjs.com/search/suggestions?q='
}

export const MESSAGES = {
  noPackageFound: 'No Package Found.',
  appName: 'Dependency Explorer'
}
